import { render, staticRenderFns } from "./FundingProjectClaimValue.vue?vue&type=template&id=6b06ce61&"
import script from "./FundingProjectClaimValue.vue?vue&type=script&lang=js&"
export * from "./FundingProjectClaimValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports